// extracted by mini-css-extract-plugin
export default {"announcements__buttonGroup":"Announcements_announcements__buttonGroup__EXSpv","announcements__dataButton":"Announcements_announcements__dataButton__TpB-n"};